import React, { Component } from 'react'
import { Loader } from '@components/UI'
import { ClassroomManager } from '@helpers'

import { Zoom } from './Tools'
import Pagination from './Pagination'
import TabBar from './TabBar'
import Fallback from './Fallback'
import { useAuth } from '@hooks'
import { useClassroomQuery, useFileCreate } from '@components/Classroom/hooks'

class Frame extends Component {
  create = () => {
    const { props } = this
    const {
      user,
      classroom: { id, mode, participants }
    } = props

    props
      .createFile({
        name: this.name(),
        type: props.component.type,
        participants: [user.id, ...Object.keys(participants || {})],
        ...(mode !== 'individual' ? { appointment: id } : {})
      })
      .then((file) => {
        ClassroomManager.openFile({
          id: file.id,
          type: file.type,
          name: file.name
        })
      })
  }

  name = () => {
    let i = 1
    while (
      Object.values(this.props.tabs)
        .map((v) => v.data.name)
        .includes(`${this.props.component.title} ${i}`)
    )
      i++
    return `${this.props.component.title} ${i}`
  }

  render() {
    const { props } = this
    const {
      className,
      id,
      children,
      events = {},
      theme = '',
      progress,
      tabs,
      tabBar
    } = props
    const loading = props.loading

    return (
      <div
        className={`gp-frame ${className} ${theme}`}
        {...(id ? { id } : {})}
        {...events}
        style={props.style || {}}
      >
        {props.toolbar}

        {tabs && Object.keys(tabs).length ? (
          <React.Fragment>
            <div
              className='children-container'
              style={loading ? { filter: `url('#blur')` } : {}}
            >
              {progress && (
                <div
                  className='progress-bar'
                  style={{ width: `${progress}%` }}
                />
              )}
              {children}
            </div>

            <TabBar
              tabs={tabs}
              active={props.active}
              activate={(id) =>
                ClassroomManager.activateFile({
                  type: props.component.type,
                  id
                })
              }
              close={(id) =>
                ClassroomManager.closeFile({ type: props.component.type, id })
              }
              create={this.create}
            />
          </React.Fragment>
        ) : tabs ? (
          <Fallback create={this.create} type={props.component.type} />
        ) : (
          <React.Fragment>
            <div
              className='children-container'
              style={loading ? { filter: `url('#blur')` } : {}}
            >
              {children}
            </div>
            {!!tabBar && tabBar}
          </React.Fragment>
        )}

        {((tabs && Object.keys(tabs).length) || !tabs) &&
          props.zoomControls && (
            <Zoom
              style={props.zoomControls.style}
              onZoomIn={props.zoomControls.onZoomIn}
              onZoomOut={props.zoomControls.onZoomOut}
            />
          )}

        {props.pagination && (
          <Pagination
            page={props.pagination.page}
            total={props.pagination.numPages}
          />
        )}

        {loading && (
          <Loader
            full
            icon
            style={{ height: `calc(100% - 104px)`, top: '52px' }}
          />
        )}
      </div>
    )
  }
}

const FrameWrapper = (props) => {
  const { profile } = useAuth()
  const { data } = useClassroomQuery()
  const { mutateAsync: createFile } = useFileCreate()

  return (
    <Frame {...props} user={profile} classroom={data} createFile={createFile} />
  )
}

export default FrameWrapper
